/**
 * @generated SignedSource<<1ecc8eaddb12499664651f3e260b1522>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ExternalDepositViewTokensQuery$variables = {};
export type ExternalDepositViewTokensQuery$data = {
  readonly tokens: ReadonlyArray<{
    readonly symbol: string;
    readonly crypto: string;
    readonly name: string;
    readonly logo: string;
    readonly min: string;
    readonly price: string;
    readonly coinId: string;
    readonly status: number;
    readonly tokens: ReadonlyArray<{
      readonly tokenId: string;
      readonly crypto: string;
      readonly logo: string;
      readonly name: string;
      readonly network: string;
      readonly chain: string;
      readonly contract: string;
      readonly chainLogo: string;
      readonly status: number;
    }>;
  }>;
};
export type ExternalDepositViewTokensQuery = {
  variables: ExternalDepositViewTokensQuery$variables;
  response: ExternalDepositViewTokensQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "crypto",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CCoin",
    "kind": "LinkedField",
    "name": "tokens",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "symbol",
        "storageKey": null
      },
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "min",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "coinId",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CToken",
        "kind": "LinkedField",
        "name": "tokens",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tokenId",
            "storageKey": null
          },
          (v0/*: any*/),
          (v2/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "network",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contract",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chainLogo",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalDepositViewTokensQuery",
    "selections": (v4/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ExternalDepositViewTokensQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "e32fec11a795a37a6f0bea222d6d2bc6",
    "id": null,
    "metadata": {},
    "name": "ExternalDepositViewTokensQuery",
    "operationKind": "query",
    "text": "query ExternalDepositViewTokensQuery {\n  tokens {\n    symbol\n    crypto\n    name\n    logo\n    min\n    price\n    coinId\n    status\n    tokens {\n      tokenId\n      crypto\n      logo\n      name\n      network\n      chain\n      contract\n      chainLogo\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "34ced141fa03cd8e1e5700ac4af766be";

export default node;
